import styled from 'styled-components';

export const DetailsItem = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ItemLabel = styled.label`
  color: #999;
  width: 220px;
  font-size: 16px;
  font-weight: normal;
  white-space: normal;
  margin-right: 30px;
  vertical-align: top;
  text-transform: none;
  display: inline-block;
`;

export const ItemValue = styled.div`
  font-size: 16px;
  text-align: left;
  display: inline-block;
`;

export const ContactNumber = styled.div`
  display: inline-block;
  margin-right: 10px;
  > small {
    color: #999;
  }
`;

export const AgeBreakdown = styled.div`
  &:not(:last-child) {
    margin-bottom: 5px;
  }
  > span:first-child {
    display: inline-block;
    width: 100px;
  }
  > span:nth-child(2) {
    margin-left: 20px;
  }
`;

export const GuestRelationHeading = styled.div`
  color: #999;
  font-size: 13px;
  font-weight: bold;
`;
